import { setDecimalPrecision } from 'helper/util';
import moment from 'moment';

const calculateBusinessDaysInclusive = (startDate, endDate) => {
    let count = 0;

    while (startDate.isSameOrBefore(endDate)) {
        if (startDate.day() !== 0 && startDate.day() !== 6) {
            count++;
        }
        startDate.add(1, 'days');
    }

    return count;
};
const getNoOfWorkingDays = (startDate, endDate, includeSaturday, includeSunday) => {
    const formattedStartDate = moment(moment(startDate).format());
    const formattedEndDate = moment(moment(endDate).format());
    const workingDays = calculateBusinessDaysInclusive(formattedStartDate, formattedEndDate);

    return workingDays + (includeSaturday ? 1 : 0) + (includeSunday ? 1 : 0);
};
const AllocationHourRevereseWrapper = (startDate, endDate, weeklyHours, includeSaturday, includeSunday) => {
    // const noOfWorkingDays = getNoOfWorkingDays(startDate, endDate, includeSaturday, includeSunday);

    // if (noOfWorkingDays < 5 && !includeSaturday && !includeSunday) {
    //     return setDecimalPrecision((weeklyHours / 5) * noOfWorkingDays);
    // }
    // if (noOfWorkingDays < 7 && includeSaturday && includeSunday) {
    //     return setDecimalPrecision((weeklyHours / 7) * noOfWorkingDays);
    // }
    // if (noOfWorkingDays < 6 && (includeSaturday || includeSunday)) {
    //     return setDecimalPrecision((weeklyHours / 6) * noOfWorkingDays);
    // }
    return Math.round(weeklyHours);
};
export default AllocationHourRevereseWrapper;
